import $ from "jquery";
$(() => {
    $('span[data-badge-get-url]').each((index, item) => {
        const url = $(item).data('badge-get-url');
        $.get(url, (data) => {
            $(item).text(data.Count);
            if (data.Count > 0) {
                $(item).removeClass('hidden');
            }
            else {
                $(item).addClass('hidden');
            }
        });
    });
});
